import {Trans, useTranslation} from '@/translations/i18n.tsx'
import {useVideoUpload} from '@features/video-upload/store.ts'
import {useAsync} from '@hooks/useAsync.ts'
import {httpDeleteMedia} from '@features/video-upload/http/videoUpload.http.ts'
import {errorHandler, raise} from '@utilities/helpers.ts'
import {VideoUploadModalWrapper} from '@features/video-upload/components/video-upload-modal-wrapper'
import {ModalBody, ModalFooter} from '@components/ui/modal-atoms'
import {Button} from '@components/ui/button'
import {AlertTriangleIcon} from '@components/ui/icon'
import {VideoCard} from '@features/video-upload/components/video-card'

export const UploadedStep = () => {
    const {t} = useTranslation()
    const setIsOpen = useVideoUpload(store => store.setIsOpen)
    const setStep = useVideoUpload(store => store.setStep)
    const setFile = useVideoUpload(store => store.setFile)
    const file = useVideoUpload(store => store.file)
    const assignmentId = useVideoUpload(store => store.assignmentId)
    const darylDirectoryId = useVideoUpload(store => store.darylDirectoryId)
    const deleteVideo = useAsync()

    const handleDeleteVideo = async () => {
        try {
            await deleteVideo.run(
                httpDeleteMedia({
                    urlParams: {
                        assignmentId: assignmentId ?? raise('assignmentId is nullish'),
                        mediaId: file?.id ?? raise('mediaId is nullish')
                    }
                })
            )
            setFile(file)
            setStep('idle')
        } catch (error) {
            errorHandler(error)
        }
    }

    return (
        <VideoUploadModalWrapper>
            <ModalBody>
                <VideoCard isLoading={deleteVideo.isLoading} onDeleteVideo={handleDeleteVideo} fileName={file?.name} />
                <p className="flex items-center gap-4 text-sm font-medium [&>a]:cursor-pointer [&>a]:underline [&>svg]:fill-orange-600">
                    <AlertTriangleIcon size={20} />
                    <Trans
                        i18nKey="assignment:remember_daryl"
                        components={{
                            link: (
                                <a
                                    href={`https://airbnb.orangelogic.com/asset-management/${darylDirectoryId}?Flat=y&WS=AssetManagement`}
                                    target="_blank"
                                />
                            )
                        }}
                    />
                </p>
            </ModalBody>
            <ModalFooter>
                <Button className="w-full" variant="tertiary" onClick={() => setIsOpen(false)}>
                    {t('commons:close')}
                </Button>
            </ModalFooter>
        </VideoUploadModalWrapper>
    )
}
